// extracted by mini-css-extract-plugin
export default {"login-container":"ResetPassword_login-container__BidcB","login-img":"ResetPassword_login-img__HnIJ6"};